import gql from 'graphql-tag';

const GET_VIDEO_DATA = gql`
  query MyStageVideo($input: MyStageVideoInput!) {
    mystage_video(input: $input) {
      video_type
      video_url
      video_label
      video_subscription_url
    }
  }
`;

export { GET_VIDEO_DATA };
